import { Card } from "antd";

const ProfileBusinessInfo = ({ data }) => {
  return (
    <Card className="border-2 shadow-md border-gray-200 sm:w-54.1  w-full bg-white">
      <div className="grid sm:grid-cols-2 sm:space-x-8">
        <div className="break-all">
          <div className="flex items-center sm:items-start sm:ml-1.5 flex-col">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Business Type
            </p>
            <p className="font-medium mt-0">{data?.businessTypeId?.name}</p>
          </div>
          <div className="flex sm:ml-1.5 flex-col sm:items-start items-center">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Business Address
            </p>
            <p className="font-medium mt-0 break-all">
              {data?.businessAddress}
            </p>
          </div>
          <div className="flex items-center sm:items-start sm:ml-1.5 flex-col">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Years In Business
            </p>
            <p className="font-medium mt-0">{data?.yearsInBusiness}</p>
          </div>
        </div>
        <div>
          <div className="flex items-center sm:items-start flex-col">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Business Name
            </p>
            <p className="font-medium mt-0 break-all">{data?.businessName}</p>
          </div>
          <div className="flex flex-col mr-1.5 sm:items-start items-center">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Website
            </p>
            <p className="font-medium mt-0 w-full max-w-[190px] break-words breal-all">
              {data?.website}
            </p>
          </div>
          <div className="flex items-center sm:items-start flex-col mr-1.5">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Staff Size
            </p>
            <p className="font-medium mt-0">{data?.staffSize}</p>
          </div>
        </div>
      </div>
      {/* <div className="flex sm:flex-row sm:space-x-20 flex-col items-center">
        <div className="flex sm:ml-1.5 flex-col">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Business Type
          </p>
          <p className="font-medium mt-0">{data?.businessTypeId?.name}</p>
        </div>
        <div className="flex flex-col">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Business Name
          </p>
          <p className="font-medium mt-0">{data?.businessName}</p>
        </div>
      </div> */}
      {/* <div className="flex sm:flex-row sm:space-x-17 flex-col  ">
        <div className="flex sm:ml-1.5 flex-col sm:items-start items-center">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Business Address
          </p>
          <p className="font-medium mt-0 ">{data?.businessAddress}</p>
        </div>
        <div className="flex flex-col mr-1.5 sm:items-start items-center">
          <p className="font-medium text-primaryPurple text-lg mb-0">Website</p>
          <p className="font-medium mt-0">{data?.website}</p>
        </div>
      </div> */}
      {/* <div className="flex sm:flex-row sm:space-x-17 flex-col items-center">
        <div className="flex sm:ml-1.5 flex-col">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Years In Business
          </p>
          <p className="font-medium mt-0">{data?.yearsInBusiness}</p>
        </div>
        <div className="flex flex-col mr-1.5">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Staff Size
          </p>
          <p className="font-medium mt-0">{data?.staffSize}</p>
        </div>
      </div> */}
    </Card>
  );
};

export default ProfileBusinessInfo;
